module.exports = "<top-module-nav class=\"top-nav\"></top-module-nav>\r\n<div class=\"fixed-right-content\" ui-view>\r\n</div>";